import { render, staticRenderFns } from "./BusinessUnitDetails.vue?vue&type=template&id=66a4470b&"
import script from "./BusinessUnitDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports